import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MFA_OAUTH_URL,
  MULTI_FACTOR_EndpointKey
} from '../../../../constants/login/login-remember-me-constant';
import {
  LoginAuthWithCredentialsResponse,
  OauthAEMConfig,
  PostWithCredentials
} from '../../../../models/login';
import { LoginRememberMeUtilsService } from '../../../../utils/login/login-remember-me-utils.service';
import { HttpHeadersPayload, ReplaceItem } from '../../../../models/utils';
import { ApiBuilder, AppConfigService, handleError } from '../../../utils';
import { HttpRequestMethods, IDP_APP } from '../../../../constants/utils';

@Injectable({
  providedIn: 'root'
})
export class LoginPostWithFingerPrintService {
  loginAuthHeaderForFingerprint: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.submitDeviceInformation+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private utils: LoginRememberMeUtilsService,
    private http: HttpClient,
    private appConfig: AppConfigService
  ) {}

  loginPostWithFingerPrint = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<LoginAuthWithCredentialsResponse> => {
    const uniqueIdentifier = this.utils.generateUniqueIdentifier();
    const encryptedTokenStored = this.utils.getLocalStorageValue('encyToken');
    const uniqueIdentifierStored = this.utils.getLocalStorageValue('uid');

    let payload: PostWithCredentials = {};

    if (encryptedTokenStored && uniqueIdentifierStored) {
      payload = {
        fingerprint: uniqueIdentifierStored,
        encryptedToken: encryptedTokenStored
      };
    } else {
      payload = {
        fingerprint: uniqueIdentifier
      };
    }

    const getLoginPostWithFingerPrintUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const loginPostWithFingerPrintUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getLoginPostWithFingerPrintUrl
      }
    ];

    return new ApiBuilder<
      PostWithCredentials,
      LoginAuthWithCredentialsResponse
    >(this.http, this.appConfig)
      .app(IDP_APP.COMMON)
      .endpointKey(MULTI_FACTOR_EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(loginPostWithFingerPrintUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.LOGIN_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.loginAuthHeaderForFingerprint)
      .errorHandler(this._errorHandler)
      .library('LOGIN_POST_WITH_FINGER_PRINT_SERVICE')
      .withCredentials(true)
      .create();
  };
}
